export default __webpack_public_path__ + "static/currys-horizontal-b6e26a1a7149d1646cefb30907a3776b.png";